export const pay = (data) => {
  var payform = $('<form></form>')
  payform.attr('action', data.url)
  payform.attr('method', 'post')
  payform.attr('target', '_blank')
  payform.append(
    "<input type='hidden' name='sysId' value='" + data.sysId + "'/>"
  )
  payform.append(
    "<input type='hidden' name='merchantNumber' value='" +
      data.merchantNumber +
      "'/>"
  )
  payform.append(
    "<input type='hidden' name='bsOrderNum' value='" + data.bsOrderNum + "'/>"
  )
  payform.append(
    "<input type='hidden' name='payAmount' value='" + data.payAmount + "'/>"
  )
  payform.append("<input type='hidden' name='serviceCharge' value='0'/>")
  payform.append(
    "<input type='hidden' name='orderCategory' value='" +
      data.orderCategory +
      "'/>"
  )
  payform.append(
    "<input type='hidden' name='bsPayerName' value='" + data.bsPayerName + "'/>"
  )
  payform.append(
    "<input type='hidden' name='checkValue' value='" + data.checkValue + "'/>"
  )
  payform.append(
    "<input type='hidden' name='payeeCompanyId' value='" +
      data.payeeCompanyId +
      "'/>"
  )
  payform.append(
    "<input type='hidden' name='payeeCompanyName' value='" +
      data.payeeCompayname +
      "'/>"
  )
  payform.append(
    "<input type='hidden' name='attr1' value='" + data.attr1 + "'/>"
  )
  payform.append(
    "<input type='hidden' name='attr5' value='" + data.attr5 + "'/>"
  )
  payform.append(
    "<input type='hidden' name='attr7' value='" + data.attr7 + "'/>"
  )

  payform.append(
    "<input type='hidden' name='orderSuject' value='" + data.orderSuject + "'/>"
  )
  payform.append(
    "<input type='hidden' name='orderSubject' value='" +
      data.orderSubject +
      "'/>"
  )
  payform.append(
    "<input type='hidden' name='orderBody' value='" + data.orderBody + "'/>"
  )
  payform.append(
    "<input type='hidden' name='bgUrl' value='" + data.bgUrl + "'/>"
  )
  payform.append(
    "<input type='hidden' name='pgUrl' value='" + data.pgUrl + "'/>"
  )

  payform.appendTo('body')
  payform.css('display', 'none')
  payform.submit()
}

export const payOutModal = () => {}
